document.addEventListener('DOMContentLoaded', () => {
	const infoBanner = document.querySelector('.js-info-banner');
	const INFO_BANNER_HIDDEN_CLASS = 'info-banner_hidden';

	if (infoBanner) {
		const hideBtn = infoBanner.querySelector('.info-banner__close-btn');

		const showinfoBanner = () => {
			infoBanner.classList.remove(INFO_BANNER_HIDDEN_CLASS);
		};

		hideBtn.addEventListener('click', () => {
			sessionStorage.setItem('info-banner', 'accepted');
			infoBanner.classList.add(INFO_BANNER_HIDDEN_CLASS);
		});

		if (sessionStorage.getItem('info-banner') !== 'accepted') {
			showinfoBanner();
		}
	}
});
